var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPencilDesign(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 43,
    height: 42,
    viewBox: "0 0 43 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "design 1",
    clipPath: "url(#clip0_492_5175)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M39.383 24.158V17.8422L34.9207 17.0065C34.654 16.151 34.3042 15.3313 33.8804 14.5558L36.4314 10.882L31.8589 6.41583L28.0976 8.90753C27.3037 8.49353 26.4645 8.15195 25.5889 7.89175L24.733 3.5332H18.2669L17.4113 7.89175C16.5353 8.15195 15.6962 8.49353 14.9022 8.90753L11.141 6.41583L6.56877 10.882L9.11947 14.5558C8.69561 15.3313 8.34589 16.151 8.07951 17.0065L3.61719 17.8422V24.158L8.07951 24.994C8.34589 25.8492 8.69561 26.6689 9.11947 27.4444L6.56877 31.1181L11.141 35.5844L14.9022 33.0927C15.6962 33.5067 16.5353 33.8482 17.4113 34.1084L18.2669 38.467H24.733L25.5889 34.1084C26.4645 33.8482 27.3037 33.5067 28.0976 33.0927L31.8589 35.5844L36.4314 31.1181L33.8804 27.4444C34.3042 26.6689 34.6543 25.8492 34.9207 24.994L39.383 24.158Z",
    fill: "#27488F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M39.3831 24.158V17.8422L34.9207 17.0065C34.654 16.151 34.3043 15.3313 33.8805 14.5558L36.4315 10.882L31.8589 6.41583L28.0977 8.90753C27.3038 8.49353 26.4646 8.15195 25.589 7.89175L24.7331 3.5332H21.5V38.4673H24.7331L25.589 34.1087C26.4646 33.8482 27.3038 33.5067 28.0977 33.0927L31.8589 35.5844L36.4315 31.1181L33.8805 27.4444C34.3043 26.6689 34.6544 25.8492 34.9207 24.994L39.3831 24.158Z",
    fill: "#1B3B6B"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M31.0392 20.9999C31.0392 26.1461 26.7678 30.3178 21.4991 30.3178C16.2304 30.3178 11.959 26.1461 11.959 20.9999C11.959 15.8537 16.2304 11.6816 21.4991 11.6816C26.7678 11.6816 31.0392 15.8537 31.0392 20.9999Z",
    fill: "#F2F6FC"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M31.0401 20.9999C31.0401 26.1461 26.7687 30.3178 21.5 30.3178C21.5 21.2642 21.5 16.3686 21.5 11.6816C26.7687 11.6816 31.0401 15.8537 31.0401 20.9999Z",
    fill: "#DCE1EB"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M0 41.9999L9.82616 39.8065L13.4955 36.2225L5.91498 28.8179L2.24559 32.4023L0 41.9999Z",
    fill: "#FCF2B6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M0 42L9.82616 39.8066L13.4955 36.2226L9.70543 32.5203L0 42Z",
    fill: "#FFDE91"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M33.8519 1.531L4.19531 30.498L5.74049 36.393L11.7759 37.9022L41.4325 8.93528C43.5226 6.89379 43.5226 3.57249 41.4325 1.531C39.3427 -0.510172 35.942 -0.510492 33.8519 1.531Z",
    fill: "#FFBC36"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_8",
    d: "M5.74023 36.393L11.7756 37.9023L41.4322 8.93529C43.5223 6.8938 43.5223 3.57217 41.4322 1.53101C38.8038 4.09833 5.74023 36.393 5.74023 36.393Z",
    fill: "#FFA426"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_9",
    d: "M38.0845 12.2054L30.5039 4.80148L33.8518 1.53112C35.9419 -0.510048 39.3423 -0.510048 41.4324 1.53112C43.5225 3.57261 43.5225 6.89391 41.4324 8.9354L38.0845 12.2054Z",
    fill: "#FE6A16"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_10",
    d: "M38.0854 12.2053L34.2949 8.50334C34.2949 8.50334 38.172 4.71645 41.4333 1.53101C43.5233 3.57217 43.5233 6.8938 41.4333 8.93529L38.0854 12.2053Z",
    fill: "#F24500"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_11",
    d: "M0 42.0001L5.74702 40.7171L1.31357 36.3867L0 42.0001Z",
    fill: "#27488F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_12",
    d: "M0 42L5.74702 40.7169L3.53029 38.5518L0 42Z",
    fill: "#1B3B6B"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_492_5175"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 43,
    height: 42,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPencilDesign);
export default __webpack_public_path__ + "static/media/pencil-design.1beff4faa81f5d41c1f188b9ef218e83.svg";
export { ForwardRef as ReactComponent };